import * as React from 'react';

export interface IT4IconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const T4Icon = React.forwardRef<SVGSVGElement, IT4IconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404 0 0 1.0404 -98.016 -47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <text x="97.087555" y="47.709003" fontFamily="sans-serif" fontSize="4.6513px" xmlSpace="preserve">
                  <tspan x="97.087555" y="47.709003" strokeWidth=".0072031" />
                </text>
                <g aria-label="T1">
                  <path d="m96.966 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                  <g transform="scale(.9661 1.0351)" strokeWidth=".0025" aria-label="4">
                    <path
                      d="m102.85 44.537q0-0.03238 6e-3 -0.05299l0.79458-2.72q0.0421-0.1413 0.19263-0.1413 0.19865 0 0.19865 0.19428 0 0.02649-9e-3 0.05593l-0.72236 2.4698h0.93003v-0.58285q0-0.19428 0.19865-0.19428t0.19865 0.19428v0.58285h0.39729q0.19865 0 0.19865 0.19428t-0.19865 0.19428h-0.39729v0.58285q0 0.19428-0.19865 0.19428t-0.19865-0.19428v-0.58285h-1.1919q-0.19864 0-0.19864-0.19428z"
                      strokeWidth=".0024724"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
